import { makeStyles, Theme } from "@material-ui/core";

interface CardDestinatarioStylesProps {
    ativo: boolean;
}

export const useStyles = makeStyles<Theme, CardDestinatarioStylesProps>((theme) => ({
    gridContainer: {
        '& p': {
            fontSize: 12
        }
    },
    status: {
        backgroundColor: ({ ativo }) => ativo ? theme.palette.success.main : theme.palette.error.main,
        width: '5px',
        borderRadius: '5px',
        margin: '7px'
    },
    cardContent: {
        display: 'flex',
        alignItems: 'center',
        flex: 1,
        padding: theme.spacing(1)
    }
}))